<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <div class="cs-form-intro-large pt-6 pb-4">
            {{ $t("newaccount.title") }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="6" class="pr-md-8 pr-sm-0 title">{{
          $t("newaccount.intro")
        }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="pt-10 pb-8">
          <v-btn class="primary" @click="openOrderPage">
            {{ $t("newaccount.button.makeOrder") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");

export default {
  name: "register",
  data() {
    return {
      csNbr: 0,
    };
  },
  methods: {
    openOrderPage() {
      // const lang = this.$store.state.userProfile.lang;
      const getToken = fb.fnct.httpsCallable("getToken");
      const payload = {
        uid: this.$store.state.currentUser.uid,
      };
      getToken(payload).then((response) => {
        const token = response.data.token.orderToken;
        window.open(
          "https://crashstickers.com/agent-order-" + token + ".html",
          "cs_order_" + token,
          "location=yes,height=870,width=820,scrollbars=yes,status=yes"
        );
      });
    },
  },
};
</script>

<style></style>
